<template>
    <div id="accordion">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return { cards: [] }
        },

        created() {
            this.cards = this.$children;
        }
    }
</script>